<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent scrollable  max-width="600px">
      <!--template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template-->
      <v-card>
        <v-card-title>
          <span class="headline">Comercial</span>
          <v-btn float-right color="secondary" flat @click="rutas();">Rutas</v-btn>
        </v-card-title>

        <v-card-text v-if="$store.state.newCust">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 v-if="$store.state.newCust">
                <formCliente/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-text v-if="!$store.state.newCust">
          <v-container grid-list-md>
            <v-layout wrap>
                <v-radio-group v-model="tipoDocumento" row>
              <v-flex xs12 sm6 md4>                
                <v-radio color="secondary" label="Preventa" value="preventa"></v-radio>                                    
              </v-flex>
              <v-flex xs12 sm6 md4 >
                <v-radio color="secondary" v-if="$store.state.appconfig.autoventa" label="Autoventa" value="autoventa"></v-radio>
              </v-flex>
              <v-flex xs12 sm6 md4 >
                <v-radio label="Abono" value="abono"></v-radio>
              </v-flex>
              <v-flex xs12>
                
              </v-flex>
                </v-radio-group>
              <v-flex xs10 >
                <v-text-field v-model="custFilter" label="Cliente" placeholder="Introduzca al menos 3 caracteres para buscar" type="text" required></v-text-field>
              </v-flex>  
              <v-flex xs2>
                <v-btn
                  color="primary"
                  fab
                  small
                  dark
                  @click="$store.state.newCust = !$store.state.newCust"
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                  <v-container
                    id="scroll-target"
                    style="max-height: 200px"
                    class="scroll-y"
                    fluid
                    pa-0
                    > 
                    <listaClientes v-if="custFilter.length > 2"/>   
                  </v-container>
              </v-flex>         
              <!--v-flex xs12 sm6>
                <v-autocomplete                
                  :items="$store.state.customers"
                  label="Interests"
                  multiple
                ></v-autocomplete>
              </v-flex-->
            </v-layout>
          </v-container>
          <!--small>*indicates required field</small-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!--v-btn color="blue darken-1" flat @click="dialog = false">Cerrar</v-btn-->
          <v-btn v-if="$store.state.newCust" color="secondary" flat @click="$store.state.newCust = !$store.state.newCust">Volver</v-btn>
          <v-btn v-if="$store.state.newCust" color="primary" flat @click="createNewCust()">Aceptar</v-btn>
          <v-btn v-if="!$store.state.newCust" :loading="loading_" :disabled="!$store.state.customers.length || !custFilter || (custFilter.length < 3)" color="primary" flat @click="validateDialog()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import listaClientes from '@/components/listaClientes.vue'
import formCliente from '@/components/formCliente.vue'
  export default {
      name: 'selectorComercial',      
    data () {
      return {
        timeout: null,
        prevCust: -1
      }
    },
    methods:{
        validateDialog(){
            if ((this.tipoDocumento != '') && (this.$store.state.selectedCustIndex != -1)){                
                this.dialog = false;
                if (this.prevCust != this.$store.state.selectedCustIndex){
                  this.$store.commit('resetOrderItems');
                }
                this.getCategories();
                this.getItems();
            } else {
                this.setGlobalDialog('Faltan Datos','Debe elegir tipo de documento y cliente',false);                
            }
        },
        getCust(){
          if ((this.custFilter) && (this.custFilter.length > 2)){
            let auxthis = this;
            //Para prevenir que cierren el dialog con un cliente elegido y se cambie cuando acabe una busqueda pendiendte,
            //desde que se cambie el filtro no permitiremos cerrar la page hasta que acabe la busqueda
            this.loading_ = true; 
            this.timeout = setTimeout(function () {
                auxthis.getCustomers();               
                //console.log('test');
            }, 2000);
          }
        },
        rutas(){
          this.dialog = false;
          this.$router.push('rutas');
        }
    },
    computed: {
        custFilter:{
            get(){
                return this.$store.state.custFilter;
            },
            set(value){
                this.$store.commit('setCustFilter',value);
            }
        },
        tipoDocumento:{
            get(){
                return this.$store.state.tipoDocumento;
            },
            set(value){
                this.$store.commit('setTipoDocumento',value);
            }
        },
        dialog:{
           get(){
                return this.$store.state.dialogComercial;
            },
            set(value){
                this.$store.commit('setDialogComercial',value);
            } 
        },
        loading_:{
          get(){
                return this.$store.state.activeAxiosComms.customer;
            },
          set(value){
              this.$store.commit('setCustomerLoading',value);
          } 
        },
        selectedCustIndex:{
          get(){
            return this.$store.state.selectedCustIndex;
          }
        }
    },
    updated(){      
      this.prevCust = this.$store.state.selectedCustIndex;
    },
    watch:{
        custFilter: function(val, oldVal){
            this.getCust();
        },
        selectedCustIndex: function(val, oldVal){
            this.prevCust = oldVal;
            //console.log(this.prevCust);
        },
    },
    components: {
        listaClientes,
        formCliente
    }
  }
</script>